import {
    LOADRECONDATA,
    RESETRECONDATA,
    CHANGERECONDATA,
    SELECTALLRECONDATA,
    initialState
} from "../constant/constant";

export default function reducer(state = { ...initialState.recon }, action) {
    switch (action.type) {
        case LOADRECONDATA:
            return { ...state, reconData: [...action.reconData.map(e=>{ return {...e, selected: true}})] }

        case CHANGERECONDATA:
            return { ...state, reconData: [...state.reconData.map(e=>{ 
                if(action.id === e.id){
                    return {...e, selected: !e.selected}
                }
                else{
                    return {...e}
                }
            })] }


        case SELECTALLRECONDATA:
            return { 
                ...state, 
                reconData: [...state.reconData.map(e => ({ ...e, selected: action.selectAll }))] 
            }

        case RESETRECONDATA:
            return { ...state, reconData: [] }

  
        default:
            return { ...state };
    }
}